
import React from "react";
import { UseFormReturn } from "react-hook-form";
import { ActivityFormValues, reminderTimeOptions } from "../schema/activitySchema";
import {
  FormField,
  FormItem,
  FormLabel,
  FormControl,
  FormMessage,
} from "@/components/ui/form";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

interface ActivityReminderSelectProps {
  form: UseFormReturn<ActivityFormValues>;
}

export const ActivityReminderSelect: React.FC<ActivityReminderSelectProps> = ({ form }) => {
  return (
    <FormField
      control={form.control}
      name="reminder_time"
      render={({ field }) => (
        <FormItem>
          <FormLabel>Rappel</FormLabel>
          <Select 
            onValueChange={field.onChange} 
            defaultValue={field.value || undefined}
          >
            <FormControl>
              <SelectTrigger>
                <SelectValue placeholder="Définir un rappel" />
              </SelectTrigger>
            </FormControl>
            <SelectContent>
              <SelectItem value="none">Aucun rappel</SelectItem>
              {reminderTimeOptions.map((option) => (
                <SelectItem key={option.value} value={option.value}>
                  {option.label}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};
